<template>
  <div class="table">
    <div class="container">
      <div class="handle-box">
        <el-form :model="queryCondition" ref="queryCondition" label-position="right" label-width="120px" class="searchForm">
          <el-row>
            <el-col :span="24">
              <el-row :gutter="20">
                <el-col :span="6">
                  <el-form-item label="选择月份从" prop="monthFrom">
                    <el-date-picker v-model="queryCondition.monthFrom" type="month" value-format="yyyy-MM" format="yyyy-MM" style="width:100%"></el-date-picker>
                  </el-form-item>
                </el-col>
                <el-col :span="6">
                  <el-form-item label="选择月份至" prop="monthTo">
                    <el-date-picker v-model="queryCondition.monthTo" type="month" value-format="yyyy-MM" format="yyyy-MM" style="width:100%"></el-date-picker>
                  </el-form-item>
                </el-col>
                <el-col :span="6">
                  <el-form-item label="GRI编码" prop="griCode">
                    <el-input v-model="queryCondition.griCode" clearable style="width:100%"></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="6">
                  <el-form-item label="GRI名称" prop="griName">
                    <el-input v-model="queryCondition.griName" clearable style="width:100%"></el-input>
                  </el-form-item>
                </el-col>
              </el-row>
            </el-col>
            <el-collapse-transition>
              <el-col :span="24" v-if="isShow">
                <el-row :gutter="20">
                  <el-col :span="6">
                    <el-form-item label="工厂名称" prop="facilityName">
                      <el-input v-model="queryCondition.facilityName" clearable style="width:100%"></el-input>
                    </el-form-item>
                  </el-col>
                  <el-col :span="6">
                    <el-form-item label="Category2" prop="categoryLevel2CodesList">
                      <el-select v-model="queryCondition.categoryLevel2CodesList" clearable multiple filterable placeholder="请选择(支持多选)" style="width:100%" class="multiple_sel">
                        <el-option v-for="item in categoryList2" :label="item.name" :value="item.code" :key="item.code"></el-option>
                      </el-select>
                    </el-form-item>
                  </el-col>
                </el-row>
              </el-col>
            </el-collapse-transition>
          </el-row>
          <el-row type="flex" justify="center" align="middle">
            <el-button size="mini" @click="onSearch" type="primary">查询</el-button>
            <el-button size="mini" @click="onReset" type="primary">重置</el-button>
            <span class="arrowDown" @click="isShow=!isShow">{{isShow?'收缩':'展开'}}<i :class="isShow?'el-icon-arrow-up iconBtn':'el-icon-arrow-down iconBtn'"></i></span>
          </el-row>
        </el-form>
      </div>
      <el-row class="action-btn-row">
        <el-button size="mini" class="btn" type="primary" @click="onExport" v-acl="NUTR_DELIVERY_RATIO_DOWNLOAD">导出</el-button>
      </el-row>
      <el-row>
        <el-tabs type="border-card" v-model="activeName" @tab-click="handleClick">
          <el-tab-pane label="发货数据" name="first">
            <el-table :data="tableData1" max-height="425" border stripe style="width: 100%">
              <el-table-column prop="month" sortable :sort-method="(a,b) => sortMethods(a ,b , 'month')" label="结算月" width="180"></el-table-column>
              <el-table-column prop="griCode" sortable :sort-method="(a,b) => sortMethods(a ,b , 'griCode')" label="GRI编码" width="180"></el-table-column>
              <el-table-column prop="griName" sortable :sort-method="(a,b) => sortMethods(a ,b , 'griName')" label="GRI名称"></el-table-column>
              <el-table-column prop="griDesc" sortable :sort-method="(a,b) => sortMethods(a ,b , 'griDesc')" label="GRI描述"></el-table-column>
              <el-table-column prop="categoryLevel2Name" sortable :sort-method="(a,b) => sortMethods(a ,b , 'categoryLevel2Name')" label="Category2"></el-table-column>
              <el-table-column prop="facilityCode" sortable :sort-method="(a,b) => sortMethods(a ,b , 'facilityCode')" label="工厂编号"></el-table-column>
              <el-table-column prop="facilityName" sortable :sort-method="(a,b) => sortMethods(a ,b , 'facilityName')" label="工厂名称"></el-table-column>
              <el-table-column prop="deliveryQty" sortable :sort-method="(a,b) => sortMethods(a ,b , 'deliveryQty')" label="发货数量"></el-table-column>
              <el-table-column prop="updateDate" sortable :sort-method="(a,b) => sortMethods(a ,b , 'updateDate')" label="更新日期"></el-table-column>
            </el-table>
            <div class="pagination">
              <el-pagination @size-change="handleSizeChange1" @current-change="handleCurrentChange1" :current-page="pageNum1" :page-sizes="pageSizeList" :page-size="pageSize1" :layout="pageLayout" :total="totalCount1" :page-count="pages1">
              </el-pagination>
            </div>
          </el-tab-pane>
          <el-tab-pane label="供货比重" name="second">
            <el-table :data="tableData2" max-height="425" border stripe style="width: 100%">
              <el-table-column prop="inspectWindow" sortable :sort-method="(a,b) => sortMethods(a ,b , 'templateType')" label="检测窗口期" min-width="150"></el-table-column>
              <el-table-column prop="griCode" sortable :sort-method="(a,b) => sortMethods(a ,b , 'inspectWindow')" label="GRI编码" min-width="120"></el-table-column>
              <el-table-column prop="griName" sortable :sort-method="(a,b) => sortMethods(a ,b , 'griCode')" label="GRI名称" min-width="120"></el-table-column>
              <el-table-column prop="griDesc" sortable :sort-method="(a,b) => sortMethods(a ,b , 'griDesc')" label="GRI描述" min-width="150"></el-table-column>
              <el-table-column prop="categoryLevel2Name" sortable :sort-method="(a,b) => sortMethods(a ,b , 'categoryLevel2Name')" label="Category2" min-width="120"></el-table-column>
              <el-table-column prop="facilityCode" sortable :sort-method="(a,b) => sortMethods(a ,b , 'facilityCode')" label="工厂编号" min-width="120"></el-table-column>
              <el-table-column prop="facilityName" sortable :sort-method="(a,b) => sortMethods(a ,b , 'facilityName')" label="工厂名称" min-width="150"></el-table-column>
              <el-table-column prop="summaryQty" sortable :sort-method="(a,b) => sortMethods(a ,b , 'summaryQty')" label="发货汇总数量" min-width="180"></el-table-column>
              <el-table-column prop="ratioStr" sortable :sort-method="(a,b) => sortMethods(a ,b , 'ratioStr')" label="供货比重" min-width="120"></el-table-column>
              <el-table-column prop="updateDate" sortable :sort-method="(a,b) => sortMethods(a ,b , 'updateDate')" label="更新日期" min-width="150"></el-table-column>
              <el-table-column prop="updateByName" sortable :sort-method="(a,b) => sortMethods(a ,b , 'updateByName')" label="更新人" show-overflow-tooltip min-width="150"></el-table-column>
              <el-table-column label="操作" min-width="150" v-if="isShowColumn">
                <template slot-scope="scope">
                  <el-button @click="onUpdate(scope.row)" v-if="scope.row.updateRatioButtonFlag=='Y'" type="text" size="small">更新比例</el-button>
                </template>
              </el-table-column>
            </el-table>
            <div class="pagination">
              <el-pagination @size-change="handleSizeChange2" @current-change="handleCurrentChange2" :current-page="pageNum2" :page-sizes="pageSizeList" :page-size="pageSize2" :layout="pageLayout" :total="totalCount2" :page-count="pages2">
              </el-pagination>
            </div>
          </el-tab-pane>
        </el-tabs>
      </el-row>
    </div>
    <el-dialog title="更新比例" :visible.sync="dialogVisible" width="30%" :close-on-click-modal="false" class="fpa" @close="onClose">
      <el-form ref="updateForm" :model="updateForm" :rules="updateRules" label-width="70px">
        <el-form-item label="更新比重" prop="ratioStr">
          <el-input v-model="updateForm.ratioStr" @change="radioChange($event)" placeholder="输入范围0%~100%"></el-input>
        </el-form-item>
      </el-form>
      <el-row type="flex" justify="center" style="margin-top:10px">
        <el-button size="mini" class="btn" type="primary" @click="onSave" :disabled="isDisabled" :loading="isLoading">保存</el-button>
        <el-button size="mini" class="btn" @click="onClose">取消</el-button>
      </el-row>
    </el-dialog>
  </div>
</template>
<script>
import paginationMixin from '@/mixins/pagitionMixin';
import { apiService } from "@/api/material/material-master-data";
import nutriApi from "@/api/Nutrition/index";
// import store from '@/store/index'
export default {
  name: 'supplyProportion',
  mixins: [paginationMixin],
  data() {
    return {
      queryCondition: {
        pageSize: 15,
        pageNum: 1,
        monthFrom: "",
        monthTo: "",
        griCode: "",
        griName: "",
        facilityName: "",
        categoryLevel2CodesList: []
      },
      totalCount1: 0,
      pages1: 1,
      totalCount2: 0,
      pages2: 1,
      pageSize1: 15,
      pageNum1: 1,
      pageSize2: 15,
      pageNum2: 1,
      activeName: "first",
      isShow: false,
      tableData1: [],
      tableData2: [],
      dialogVisible: false,
      isDisabled: false,
      isLoading: false,
      updateForm: {
        ratioStr: "",
      },
      updateRules: {
        ratioStr: [
          { required: true, message: '请输入更新比重', trigger: 'blur' },
        ]
      },
      isShowColumn: false,
    };
  },
  // watch: {
  //   queryCondition() {
  //     let _this = this;
  //     store.dispatch('uploadListParams', { routeName: _this.$route.name, reqData: _this.queryCondition })
  //   }
  // },
  // beforeRouteEnter(to, from, next) {
  // QIPApi.findListPage(to.meta.reqData).then((res) => {
  //   next(vm => {
  //     vm.queryCondition = to.meta.reqData;
  //     vm.tableData = res.data.records;
  //     vm.totalCount = res.data.total;
  //   })
  // })
  // },
  mounted() {
    var permission = JSON.parse(localStorage.getItem('ms_Permission'))
    if (permission.indexOf('NUTR_DELIVERY_RATIO_UPDATE_RATIO') != -1) {
      this.isShowColumn = true
    } else {
      this.isShowColumn = false
    }
    // v-acl=""
    this.getCategory1()
    this.queryData1()
    this.queryData2()
  },
  methods: {
    getCategory1() {
      apiService.findCategory({ categoryLevel: 1 }).then((res) => {
        var pid
        res.data.forEach(ele => {
          if (ele.code == '10' && ele.name == 'Food') {
            pid = ele.tmCategoryId
          }
        })
        this.getCategory2(pid)
      });
    },
    getCategory2(pid) {
      apiService.findCategory({ categoryLevel: 2, pid: pid }).then((res) => {
        console.log("🚀 ~ file: nutritionDetection.vue:507 ~ apiService.findCategory ~ res:", res)
        this.categoryList2 = res.data;
      });
    },
    queryData1() {
      this.$set(this.queryCondition, 'pageSize', this.pageSize1)
      this.$set(this.queryCondition, 'pageNum', this.pageNum1)
      nutriApi.findDeliveryListPage(this.queryCondition).then((res) => {
        console.log("🚀 ~ file: detectionWindowPeriod.vue:135 ~ nutriApi.findListPage ~ res:", res)
        if (res.code === '200') {
          this.tableData1 = res.data.records
          this.totalCount1 = res.data.total
        }
      })
    },
    queryData2() {
      this.$set(this.queryCondition, 'pageSize', this.pageSize2)
      this.$set(this.queryCondition, 'pageNum', this.pageNum2)
      nutriApi.findDeliveryRatioListPage(this.queryCondition).then((res) => {
        console.log("🚀 ~ file: detectionWindowPeriod.vue:135 ~ nutriApi.findListPage ~ res:", res)
        if (res.code === '200') {
          this.tableData2 = res.data.records
          this.totalCount2 = res.data.total
        }
      })
    },
    handleClick(tab, event) {
      this.activeName = tab.name
    },
    radioChange(e) {
      console.log("🚀 ~ file: supplyProportion.vue:228 ~ radioChange ~ e:", e)
      var newVal = e.split('%')[0]
      console.log("🚀 ~ file: supplyProportion.vue:230 ~ radioChange ~ newVal:", newVal)
      // 判断输入的是否是数字,如果不是，返回空
      let reg = /^\d+(\.\d+)?$/
      if (!reg.test(newVal)) {
        this.updateForm.ratioStr = ''
      } else {
        if (newVal < 0) { // 如果输入的值小于0
          this.updateForm.ratioStr = ''
        } else if (newVal > 100) { // 如果输入的值大于等于100
          this.updateForm.ratioStr = ''
        } else {
          console.log("🚀 ~ file: supplyProportion.vue:242 ~ radioChange ~ newVal.toFixed(2):", (newVal * 1).toFixed(2))
          this.updateForm.ratioStr = (newVal * 1).toFixed(2) + '%'
        }
      }
    },
    onUpdate(row) {
      this.dialogVisible = true
      this.updateForm = Object.assign({}, row)
    },
    onSave() {
      this.$refs['updateForm'].validate((valid) => {
        if (valid) {
          this.isDisabled = true
          this.isLoading = true
          nutriApi.updateDeliveryRatio({
            inspectWindow: this.updateForm.inspectWindow,
            griCode: this.updateForm.griCode,
            facilityCode: this.updateForm.facilityCode,
            ratioStr: this.updateForm.ratioStr,
          }).then((res) => {
            this.isDisabled = false
            this.isLoading = false
            console.log("🚀 ~ file: supplyProportion.vue:241 ~ onSave ~ res:", res)
            if (res.code == '200') {
              this.$message.success('保存成功')
              this.onClose()
            }
            this.queryData1()
            this.queryData2()
          }).catch(error => {
            console.log('error', error.response)
            this.isDisabled = false
            this.isLoading = false
          })
        }
      })
    },
    onClose() {
      this.dialogVisible = false
      this.updateForm = {
        ratioStr: "",
      }
      this.$refs['updateForm'].resetFields();
    },
    onExport() {
      if (this.activeName == 'first') {
        this.$set(this.queryCondition, 'pageSize', this.pageSize1)
        this.$set(this.queryCondition, 'pageNum', this.pageNum1)
        nutriApi.deliveryDataListDownload(this.queryCondition).then((res) => {
          console.log("🚀 ~ file: supplyProportion.vue:187 ~ nutriApi.findDeliveryRatioListPage ~ res:", res)
        })
      } else {
        this.$set(this.queryCondition, 'pageSize', this.pageSize2)
        this.$set(this.queryCondition, 'pageNum', this.pageNum2)
        nutriApi.deliveryRatioDataListDownload(this.queryCondition).then((res) => {
          console.log("🚀 ~ file: supplyProportion.vue:193 ~ nutriApi.deliveryRatioDataListDownload ~ res:", res)
        })
      }
    },
    onSearch() {
      console.log('this.activeName', this.activeName)
      if (this.activeName == 'first') {
        this.pageSize1 = 15
        this.pageNum1 = 1
        // this.$set(this.queryCondition, 'pageNum', 1)
        this.queryData1()
      } else {
        this.pageSize2 = 15
        this.pageNum2 = 1
        this.queryData2()
        // this.$set(this.queryCondition, 'pageNum', 1)
      }
    },
    onReset() {
      this.queryCondition = {
        pageSize: 15,
        pageNum: 1,
        monthFrom: "",
        monthTo: "",
        griCode: "",
        griName: "",
        facilityName: "",
        categoryLevel2CodesList: []
      }
      this.pageSize1 = 15
      this.pageNum1 = 1
      this.pageSize2 = 15
      this.pageNum2 = 1
      this.queryData1()
      this.queryData2()
    },
    sortMethods(a, b, proptype) {
      var prop
      if (proptype==='updateDate') {
        prop='updateDateMiss'
      }else{
        prop=proptype
      }
      if (a[prop] === null || a[prop] === undefined) {
        return 1; // 将空值排在后面
      } else if (b[prop] === null || b[prop] === undefined) {
        return -1; // 将空值排在后面
      } else {
        // 自定义排序逻辑
        // console.log('a[prop] - b[prop]',a[prop] - b[prop])
        // return a[prop] - b[prop]; // 示例中使用数字类型的比较
        if (typeof a[prop] === 'string' && typeof b[prop] === 'string') {
          return a[prop].localeCompare(b[prop])
        } else {
          return a[prop] - b[prop];
        }
      }
    },
    handleSizeChange1(val) {
      this.pageSize1 = val
      this.$set(this.queryCondition, 'pageSize', this.pageSize1)
      this.queryData1()
    },
    handleCurrentChange1(val) {
      this.pageNum1 = val
      this.$set(this.queryCondition, 'pageNum', this.pageNum1)
      this.queryData1()
    },
    handleSizeChange2(val) {
      this.pageSize2 = val
      this.$set(this.queryCondition, 'pageSize', this.pageSize2)
      this.queryData2()
    },
    handleCurrentChange2(val) {
      this.pageNum2 = val
      this.$set(this.queryCondition, 'pageNum', this.pageNum2)
      this.queryData2()
    },
  }
}
</script>

  